export enum DestinationTypeEnum {
  WORDPRESS = 1,
  SHOPIFY = 2,
  GOOGLE_DOCS = 3,
}

export const DestinationTypeMap = {
  [DestinationTypeEnum.WORDPRESS]: "wordpress",
  [DestinationTypeEnum.SHOPIFY]: "shopify",
  [DestinationTypeEnum.GOOGLE_DOCS]: "google-docs",
};

export const DestinationLabelMap = {
  [DestinationTypeEnum.WORDPRESS]: "WordPress",
  [DestinationTypeEnum.SHOPIFY]: "Shopify",
  [DestinationTypeEnum.GOOGLE_DOCS]: "Google Docs",
};

// the ?type= value in the destination urls -> the destination type
export const getDestinationTypeFromParam = (
  param: string | null | undefined
): DestinationTypeEnum =>
  param === DestinationTypeMap[DestinationTypeEnum.WORDPRESS]
    ? DestinationTypeEnum.WORDPRESS
    : param === DestinationTypeMap[DestinationTypeEnum.GOOGLE_DOCS]
      ? DestinationTypeEnum.GOOGLE_DOCS
      : DestinationTypeEnum.SHOPIFY;

export enum DestinationStatusEnum {
  // wordpress
  DRAFT = "draft",
  PUBLISH = "publish",
  PENDING = "pending",
  FUTURE = "future",

  // shopify
  HIDDEN = "hidden",
  VISIBLE = "visible",
}

export enum DestinationTabs {
  ALL = "all",
  ADDED = "added",
}
